// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c4f021c","453":"9effbac8","455":"9efb0af6","977":"7dfda982"}[chunkId] + ".chunk.js";
};